import { useState } from "react"

import { Accordion, Box, Img, Text } from "ui-kit/components-branded/index"
import { ClientDiscount } from "utils/interfaces"
import { useGetPastBookingsWithPagination } from "modules/ClientAccount/hooks"
import { DiscountList } from "modules/discount/DiscountList"
import { getDiscounts, saveDiscount } from "modules/discount/api"
import { getErrorDescription } from "modules/discount/getErrorDescription"
import { PromoCode } from "modules/discount/PromoCode"
import { INITIATOR } from "modules/discount/constants"
import { useDidMount } from "utils/customHooks"

export const DiscountsCard = () => {
    const [discounts, setDiscounts] = useState<ClientDiscount[] | undefined>(undefined)
    const [promoCode, setPromoCode] = useState("")
    const [promoCodeSuccess, setPromoCodeSuccess] = useState<string | undefined>(undefined)
    const [promoCodeError, setPromoCodeError] = useState<string | undefined>(undefined)
    const { hasPastBooking } = useGetPastBookingsWithPagination()

    const resetMessages = () => {
        setPromoCodeError(undefined)
        setPromoCodeSuccess(undefined)
    }

    const changePromoCode = (promoCode: string) => {
        resetMessages()
        setPromoCode(promoCode)
    }

    const updateDiscounts = () => {
        void getDiscounts()
            .then((data) => {
                setDiscounts(data)
            })
            .catch(undefined)
    }

    const add = async () => {
        resetMessages()
        const result = await saveDiscount(promoCode)
        if (result.error) {
            setPromoCodeError(getErrorDescription(result.error))
            return
        }
        if (result.discountId === undefined) {
            setPromoCodeError("Произошла ошибка применения промокода")
            return
        }
        setPromoCodeSuccess("Промокод успешно добавлен")
        setPromoCode("")
        updateDiscounts()
    }

    useDidMount(() => {
        updateDiscounts()
    })

    if (!discounts?.length) {
        return null
    }

    return (
        <Box>
            <Accordion
                collapsed
                header={
                    <div className="is-flex">
                        <span>
                            <Img src="discounts.png" width={18} height={16} />
                        </span>
                        <Text isAccent className="px-1 is-flex-grow-1">
                            Скидка
                        </Text>
                    </div>
                }
                preview={
                    <DiscountList
                        collapsed
                        discounts={discounts}
                        initiator={INITIATOR.CLIENT_ACCOUNT}
                        hasPreviousSessions={hasPastBooking}
                    />
                }
            >
                <DiscountList
                    discounts={discounts}
                    initiator={INITIATOR.CLIENT_ACCOUNT}
                    hasPreviousSessions={hasPastBooking}
                />
                <PromoCode
                    isShowLabel={false}
                    promoCode={promoCode}
                    promoCodeSuccess={promoCodeSuccess}
                    promoCodeError={promoCodeError}
                    onPromoCodeChange={changePromoCode}
                    onApplyPromoCode={add}
                />
            </Accordion>
        </Box>
    )
}
